/**
 * -6차 「지급」탭 — `/adm/msix` (블레이드 `adm/includes/msix-give`, id 접두어 `mgv-`)
 *
 *   위  지급 — 라디오로 방법을 고른다 (기본 오더번호)
 *       오더번호로  조회(Enter)하면 받을 사람·포인트가 뜨고 다시 Enter 면 지급  `/adm/ajax/msix/order-grant`
 *       회원으로    회원을 고르면 보유·예약 요약이 뜨고, 그 자리에서 1건을 지급   `/adm/ajax/msix/give`
 *   아래 수동 지급 내역 — 회원 · 기간 · 사유 · 상태로 검색               `/adm/ajax/msix/give/list`
 *
 * 회수는 「회수」탭(Recall.js)이다. 한 판에 같이 두었더니 지급하려는 CS 도 보유 목록·회수 버튼을
 * 지나야 했고, 회수하려는 CS 도 지급 칸을 지나야 했다 — 반대 방향의 일이라 판을 나눴다.
 *
 * 일차는 1일차(오늘부터)·0일차(오늘은 대기중, 내일부터 1일차 — 작업완료 적립과 같은 자리) 중 고른다.
 */
import MsixPaneBase from './PaneBase';
import Util from '../../../Common/Util';

export default class MsixGive extends MsixPaneBase {
    constructor(opts = {}) {
        super('mgv', opts);
        this.table = null;
    }

    /** 페이지가 열릴 때 한 번. 목록은 탭을 처음 열 때(open) 만든다 */
    start() {
        if (!this.exists()) return;

        this.bindTargetMember();
        this.bindFilter(() => this.reload());

        this.el('board')
            .on('click', '#mgv-btn', () => this._give())
            .on('change blur', '#mgv-order', () => this._fillAccrue());

        $('input[name="mgv-mode"]').on('change', (e) => this.setMode(e.currentTarget.value));
        this.el('onum').on('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.lookupOrder(); } });
        this.el('ogrant')
            .on('click', '#mgv-ogrant-btn', () => this._grantOrder())
            .on('keydown', '#mgv-ogrant-memo', (e) => { if (e.key === 'Enter') { e.preventDefault(); this._grantOrder(); } });

        this.el('list').on('click', '.mg-open', (e) => {
            const $b = $(e.currentTarget);
            this.setMode('member');
            this.openMember(String($b.data('name') || ''), Util.int($b.data('mb')));
        });
    }

    /** 탭을 열 때마다 — 처음이면 목록을 만들고, 다시 열면 회수탭에서 바뀌었을 수 있으니 새로 읽는다 */
    open() {
        if (!this.table) { this._initTable(); return; }
        this.reload();
        if (this.mbNo) this.loadBoard();
    }

    reload() { if (this.table) this.table.ajax.reload(); }

    destroy() {
        if (this.table) { this.table.destroy(); this.table = null; }
        this.el('board').off();
        this.el('list').off();
        $('input[name="mgv-mode"]').off();
        this.el('onum').off();
        this.el('ogrant').off();
    }

    /** 지급 방법 — 'order'(기본) | 'member'. 주소로 들어올 때(?onum= / ?mem=)도 여기로 맞춘다 */
    setMode(mode) {
        $(`#mgv-mode-${mode}`).prop('checked', true);
        $('[data-mgv-mode]').prop('hidden', true).filter(`[data-mgv-mode="${mode}"]`).prop('hidden', false);
        this.el(mode === 'order' ? 'onum' : 'mem').trigger('focus');
    }

    // ─────────────────────────────────────────────── 오더번호로 지급

    /**
     * 오더번호 → 미리보기. 지급할 수 있으면 지급 버튼에 포커스를 줘서 Enter 한 번이면 확인창이 뜬다.
     * @param {string|number} [onum] 주소(?onum=)로 들어올 때. 없으면 칸의 값
     */
    async lookupOrder(onum) {
        if (onum) { this.setMode('order'); this.el('onum').val(onum); }
        const ordernum = Util.int(this.el('onum').val());
        const $box = this.el('ogrant');
        this.oGrant = null;
        if (!ordernum) { $box.empty(); return this.el('onum').trigger('focus'); }

        try {
            const r = await $.ajax({ url: '/adm/ajax/msix/order-grant', type: 'get', data: { ordernum }, dataType: 'json' });
            if (!r.ok) { $box.html(`<div class="text-danger">${this.esc(r.message || '오더를 찾을 수 없습니다.')}</div>`); return; }
            this.oGrant = r;
            $box.html(this._orderHtml(r));
            if (!r.block) $('#mgv-ogrant-btn').trigger('focus');
        } catch (e) {
            $box.html('<div class="text-danger">오더를 불러오지 못했습니다.</div>');
        }
    }

    _orderHtml(r) {
        const o = r.order;
        const done = String(o.doneAt || '').slice(5, 16);
        const head = `
        <div class="mg-who">
            <b>오더 ${o.num}</b>
            <span>${this.esc(o.carType)} · ${this.n(o.carPrice)}원</span>
            <span class="ms-badge">${this.esc(o.status)}</span>
            ${done ? `<span class="text-muted">작업완료 ${this.esc(done)}</span>` : ''}
        </div>`;

        const to = r.to
            ? `${$j.F.Admin.Member.Pop.cell(Util.int(r.to.mbNo), r.to.name)} <span class="text-muted">(${this.esc(r.to.why)})</span>`
            : '<span class="text-muted">-</span>';

        if (r.block) {
            return `${head}
            <div class="mg-act mt-2">
                <div class="mb-1">받을 사람 ${to}</div>
                <span class="ms-badge is-back">지급 불가</span> ${this.esc(r.block)}
            </div>`;
        }

        const nday  = Util.int(r.nday);
        const when  = nday > 0 ? `오늘 ${nday}일차` : '오늘은 대기중, 내일부터 1일차';
        const warns = (r.warns || []).map((w) => `<div class="text-danger" style="font-size:12.5px">⚠ ${this.esc(w)}</div>`).join('');

        return `${head}
        <div class="mg-act mt-2">
            <div class="mb-2">
                받을 사람 ${to}
                <span class="ms-badge is-live ml-2">포인트 ${this.n(r.pt)}원</span>
                <span class="ms-badge ml-1">시작 ${this.esc(r.startDate)} · ${when}</span>
            </div>
            ${warns ? `<div class="mb-2">${warns}</div>` : ''}
            <div class="mg-give-form">
                <div class="is-wide">
                    <label class="mb-1">지급 사유 <span class="text-muted">(비우면 '오더 ${o.num} -6차 누락 지급')</span></label>
                    <input type="text" class="form-control form-control-sm" id="mgv-ogrant-memo" placeholder="정황 (선택)">
                </div>
                <div class="is-btn">
                    <button type="button" class="btn btn-primary btn-sm" id="mgv-ogrant-btn">지급</button>
                </div>
            </div>
        </div>`;
    }

    _grantOrder() {
        const r = this.oGrant;
        if (!r || r.block) return;

        const memo = $.trim($('#mgv-ogrant-memo').val());
        const warn = (r.warns || []).length ? `<br><br><span class="text-danger">${r.warns.map((w) => this.esc(w)).join('<br>')}</span>` : '';
        const ask  = `오더 <b>${r.order.num}</b> → <b>${this.esc(r.to.name)}#${Util.int(r.to.mbNo)}</b><br><br>`
                   + `-6차 1건(<b>${this.n(r.pt)}원</b>, 시작 ${this.esc(r.startDate)})을 지급할까요?${warn}`;

        Util.swalert(ask, () => {
            $.post('/adm/ajax/msix/order-grant', { ordernum: r.order.num, memo })
                .done((res) => {
                    if (!res.ok) return $j.F.Admin.Util.tsalert('error', res.message || '지급하지 못했습니다.');
                    $j.F.Admin.Util.tsalert('success', `지급했습니다. (포인트 ${this.n(res.pt)}원)`);
                    this.lookupOrder();          // 이제 '이미 지급된 오더' 로 보인다
                    this.reload();
                    if (this.mbNo) this.loadBoard();
                    if (this.onChange) this.onChange();
                })
                .fail(() => $j.F.Admin.Util.tsalert('error', '지급 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    // ─────────────────────────────────────────────── 회원 판 (지급)

    boardHtml(r) {
        const wait   = r.wait;
        const waitNo = wait ? Util.int(wait.cnt) : 0;

        // 예약이 걸린 회원에게 주면 자정 배치가 가져갈 수 있다 — 누르기 전에 보여야 한다
        const waitWarn = waitNo > 0
            ? `<span class="ms-badge is-back">회수예약 ${waitNo}개 걸림</span>
               <span class="text-muted" style="font-size:12px">지급한 -6차가 예약분으로 회수될 수 있습니다</span>`
            : '';

        return `
        ${this.whoHtml(r, waitWarn)}

        <div class="mg-act mt-3">
            <p class="text-muted mb-2" style="font-size:12px">
                -6차 1건을 발급합니다. <b>오더번호 없이 준 건은 매일 발급일이 갱신</b>돼 만료되지 않습니다(1일차 유지).
                <b>0일차</b>는 작업완료 적립처럼 오늘은 대기중이고 내일부터 1일차입니다.
                <b class="text-danger">포인트를 비우면 매칭 순위에 영향이 없습니다.</b>
            </p>
            <div class="mg-give-form">
                <div>
                    <label class="mb-1">참조 오더번호 <span class="text-muted">(선택)</span></label>
                    <input type="text" class="form-control form-control-sm" id="mgv-order" placeholder="예: 501302">
                </div>
                <div>
                    <label class="mb-1">포인트 <span class="text-muted">(원)</span></label>
                    <input type="number" class="form-control form-control-sm" id="mgv-pt" min="0" data-amount-kor placeholder="예: 340000">
                </div>
                <div>
                    <label class="mb-1">시작 일차</label>
                    <select class="form-control form-control-sm" id="mgv-nday">
                        <option value="1">1일차 (오늘부터)</option>
                        <option value="0">0일차 (내일부터 1일차)</option>
                    </select>
                </div>
                <div class="is-wide">
                    <label class="mb-1">지급 사유 <span class="text-danger">(필수)</span></label>
                    <input type="text" class="form-control form-control-sm" id="mgv-memo" placeholder="오더번호·정황">
                </div>
                <div class="is-btn">
                    <button type="button" class="btn btn-primary btn-sm" id="mgv-btn">지급</button>
                </div>
            </div>
            <div class="text-muted mt-1" style="font-size:12px" id="mgv-info">
                오더번호를 넣으면 포인트가 자동 계산됩니다.
            </div>
        </div>`;
    }

    /** 참조 오더 → 적립 예상액을 포인트 칸에 채운다(관리자가 고쳐 쓸 수 있음) */
    async _fillAccrue() {
        const ordernum = ($('#mgv-order').val() || '').trim();
        const $info = $('#mgv-info');
        if (!ordernum) { $info.text('오더번호를 넣으면 포인트가 자동 계산됩니다.').removeClass('text-danger'); return; }

        try {
            const r = await $.ajax({ url: '/adm/ajax/msix/accrue', type: 'get', data: { ordernum }, dataType: 'json' });
            if (!r.ok) { $info.text(r.message || '오더를 찾을 수 없습니다.').addClass('text-danger'); return; }
            $('#mgv-pt').val(r.pt);
            $info.removeClass('text-danger')
                 .text(`${r.carType} · 장비대금 ${this.n(r.carPrice)}원 · ${r.workDay} → 적립 ${this.n(r.pt)}원`);
        } catch (e) {
            $info.text('적립액을 계산하지 못했습니다.').addClass('text-danger');
        }
    }

    _give() {
        if (!this.mbNo) return $j.F.Admin.Util.tsalert('error', '회원을 먼저 고르세요.');

        const memo = $.trim($('#mgv-memo').val());
        const pt   = Util.int($('#mgv-pt').val());
        if (!memo) { $j.F.Admin.Util.tsalert('error', '지급 사유를 입력하세요.'); return $('#mgv-memo').trigger('focus'); }

        const nday = Util.int($('#mgv-nday').val());
        const who  = this.esc(this.el('mem').val());
        const when = nday === 0 ? '<br><b>0일차</b> — 오늘은 대기중이고 내일부터 1일차입니다.' : '';
        const ask  = pt > 0
            ? `${who}<br><br>-6차 1건(<b>${this.n(pt)}원</b>)을 지급할까요?${when}`
            : `${who}<br><br>포인트가 0 입니다. 이 -6차는 매칭 순위에 영향을 주지 않습니다. 그래도 지급할까요?${when}`;

        Util.swalert(ask, () => {
            $.post('/adm/ajax/msix/give', { mb_no: this.mbNo, memo, pt, nday, ref_onum: $('#mgv-order').val() })
                .done((r) => {
                    if (!r.result) return $j.F.Admin.Util.tsalert('error', '지급하지 못했습니다.');
                    $j.F.Admin.Util.tsalert('success', `지급했습니다. (포인트 ${this.n(r.pt)}원)`);
                    this.loadBoard();
                    this.reload();
                    if (this.onChange) this.onChange();
                })
                .fail(() => $j.F.Admin.Util.tsalert('error', '지급 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    // ─────────────────────────────────────────────── 수동 지급 내역

    _initTable() {
        this.table = this.dataTable('#mgv-table', '/adm/ajax/msix/give/list', [
            { data: 'datetime', title: '지급일시', width: '120px', className: 'text-center',
              render: (v) => this.nowrap(String(v || '').slice(0, 16)) },
            { data: null, title: '회원', width: '150px',
              render: (d) => `${this.memCell(d)}<br>${this.openBtn(d)}` },
            { data: null, title: '포인트', width: '110px', className: 'text-right',
              render: (d) => d.initial_pt == null
                  ? '<span class="ms-badge is-back">포인트 없음</span>'
                  : `${this.n(d.current_pt)}<span class="text-muted"> / ${this.n(d.initial_pt)}</span>` },
            { data: null, title: '상태', width: '110px', className: 'text-center', render: (d) => this._state(d) },
            { data: 'ref_onum', title: '참조오더', width: '80px', className: 'text-center',
              render: (v) => Util.int(v) ? Util.int(v) : '<span class="text-muted">-</span>' },
            { data: 'manage_name', title: '등록자', width: '80px', className: 'text-center',
              render: (v) => this.nowrap(v) || '<span class="text-muted">-</span>' },
            { data: 'memo', title: '사유', className: 'mg-memo', render: (v) => this.esc(v || '') },
        ]);
    }

    /** 상태 뱃지 — -6차 관리 「내역」탭과 같은 기준 */
    _state(d) {
        const u = Util.int(d.used_ordernum);
        if (d.used_date) {
            if (u > 0)    return '<span class="ms-badge is-used">수주사용</span>';
            if (u === -1) return '<span class="ms-badge is-cancel">오더취소</span>';
            if (u === -2) return '<span class="ms-badge is-conv">발주개수전환</span>';
            if (u === -3) return '<span class="ms-badge is-back">관리자회수</span>';
            return '<span class="ms-badge">사용</span>';
        }
        const nday = Util.int(d.nday);
        return nday > 0
            ? `<span class="ms-badge is-live">보유중 ${nday}일차</span>`
            : '<span class="ms-badge is-live">대기중 (0일차)</span>';
    }
}
